import { isString } from '@impuls-coach/util-is';
import appConfig from 'helper/mapBackendConfig';

const isLocalEnvironement = process.env.REACT_APP_DEBUG_MODE === 'local';

/*
 * Generate cached asset paths for magnolia far-future-caching
 * @param {string} path		The raw asset path
 * @returns {string}
 */
export const getCachedPath = (path: string): string => {
	if (!isString(path)) {
		return '';
	}

	if (isLocalEnvironement) {
		return path;
	}

	const cacheString = `~${appConfig.env.cachingTimestamp}~cache`;
	const dotIndex = path.lastIndexOf('.');
	const assetName = path.substr(0, dotIndex);
	const assetExtension = path.substr(dotIndex, path.length);

	return `${assetName}${cacheString}${assetExtension}`;
};
